const resetForm = (id=0) => {
  document.getElementsByTagName("form")[id].reset()
};

export default resetForm;